 
  document.getElementById('customToggleBtn').addEventListener('click', function () {
    document.querySelector('.navbar-toggler').click(); // ✅ Trigger the original button
  });
 


//-------------------------header-sticky-js-start--------------

    $(window).scroll(function(){

        if ($(this).scrollTop() > 90) {

            $('header').addClass('sticky-header');

        } else {

            $('header').removeClass('sticky-header');

        }

    });

//------------------------header-sticky-js-end------------------



//--------------------------toggle-btn-js------------------------

    $(".navbar-toggler").click(function(){

        $(this).toggleClass('navbar-closed');

        $("html").toggleClass("myClass");

      });



 
//-----------------------toggle-btn-js------------------------



(function () {
  const quantityContainers = document.querySelectorAll(".quantity");  

  quantityContainers.forEach((quantityContainer) => {
      const minusBtn = quantityContainer.querySelector(".minus");
      const plusBtn = quantityContainer.querySelector(".plus");
      const inputBox = quantityContainer.querySelector(".input-box");

      updateButtonStates();

      quantityContainer.addEventListener("click", handleButtonClick);
      inputBox.addEventListener("input", handleQuantityChange);

      function updateButtonStates() {
          const value = parseInt(inputBox.value);
          minusBtn.disabled = value <= 1;
          plusBtn.disabled = value >= parseInt(inputBox.max);
      }

      function handleButtonClick(event) {
          event.preventDefault();  
          if (event.target.classList.contains("minus")) {
              decreaseValue();
          } else if (event.target.classList.contains("plus")) {
              increaseValue();
          }
      }

      function decreaseValue() {
          let value = parseInt(inputBox.value);
          value = isNaN(value) ? 1 : Math.max(value - 1, 1);
          inputBox.value = value;
          updateButtonStates();
          handleQuantityChange();
      }

      function increaseValue() {
          let value = parseInt(inputBox.value);
          value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max));
          inputBox.value = value;
          updateButtonStates();
          handleQuantityChange();
      }

      function handleQuantityChange() {
          let value = parseInt(inputBox.value);
          value = isNaN(value) ? 1 : value;

          // Execute your code here based on the updated quantity value
          console.log("Quantity changed:", value);
      }
  });
})();

//-------------------------------quantity-button---------------------------


//-----------------------owl-js-start--------------------------





$('.best-seller-slider').owlCarousel({
  loop:true,
  margin:10,
  nav:false,
  dots:false,
  responsive:{
      0:{
          items:1.5
      },
      600:{
          items:3
      },
      1000:{
          items:5
      }
  }
})




$('.single-product-slider').owlCarousel({
    loop:true,
    margin:10,
    nav:false,
    dots:true,
    responsive:{
        0:{
            items:1
        },
        767:{
            items:1
        }
    }
  })

$('.arrivals-slider').owlCarousel({
  loop:true,
  margin:10,
  nav:false,
  dots:false,
  responsive:{
      0:{
          items:1.5
      },
      600:{
          items:3
      },
      1000:{
          items:5
      }
  }
})


$('.journal-slider').owlCarousel({
  loop:true,
  margin:10,
  nav:false,
  dots:false,
  responsive:{
      0:{
          items:1.2
      },
      600:{
          items:3
      },
      1000:{
          items:5
      }
  }
})

$('.instagram-slider').owlCarousel({
  loop:true,
  margin:10,
  nav:false,
  dots:false,
  responsive:{
      0:{
          items:1.8
      },
      600:{
          items:3
      },
      1000:{
          items:5
      }
  }
})
     
//-----------------------owl-js-end---------------------------

 






document.addEventListener("DOMContentLoaded", function() {
    const video = document.getElementById('aboutVideo');
    const playButton = document.getElementById('playButton');
    let videoPlayedOnScroll = false;
  
    // Auto-play video on scroll into view
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !videoPlayedOnScroll) {
          video.play();
          videoPlayedOnScroll = true;
        }
      });
    }, {
      threshold: 0.5
    });
  
    observer.observe(document.querySelector('.about-oscar-section'));
  
    // Manual play/pause button
    playButton.addEventListener('click', function() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  });


//------------------------menu-dropdown-js-start------------------
$(document).ready(function () {
  // Remove Bootstrap default dropdown attributes
  $(".drophero").removeAttr("data-bs-toggle");

  function initDropdownBehavior() {
    // Unbind old events
    $(".nav-item.dropdown").off("mouseenter mouseleave");
    $(".drophero").off("click");
    $(document).off("click.dropdownClose");

    if ($(window).width() >= 992) {
      // Desktop: Hover behavior
      var timeout;
      $(".nav-item.dropdown").hover(
        function () {
          clearTimeout(timeout);
          $(this).addClass("show");
          $(this).find(".dropdown-menu").addClass("show");
        },
        function () {
          var $this = $(this);
          timeout = setTimeout(function () {
            $this.removeClass("show");
            $this.find(".dropdown-menu").removeClass("show");
          }, 300);
        }
      );
    } else {
      // Mobile: Click toggle only on .drophero
      $(".drophero").on("click", function (e) {
        e.preventDefault(); // Prevent # navigation
        e.stopPropagation(); // Stop bubbling to parent <a>

        var $parent = $(this).closest(".nav-item.dropdown");
        var $menu = $parent.find(".dropdown-menu");

        // Toggle current dropdown
        if ($parent.hasClass("show")) {
          $parent.removeClass("show");
          $menu.removeClass("show");
        } else {
          // Close all others first
          $(".nav-item.dropdown").removeClass("show");
          $(".dropdown-menu").removeClass("show");

          $parent.addClass("show");
          $menu.addClass("show");
        }
      });

      // Close dropdown on outside click
      $(document).on("click.dropdownClose", function (e) {
        if (!$(e.target).closest(".nav-item.dropdown").length) {
          $(".nav-item.dropdown").removeClass("show");
          $(".dropdown-menu").removeClass("show");
        }
      });
    }
  }

  // Init on page load
  initDropdownBehavior();

  // Re-init on window resize
  $(window).on("resize", function () {
    initDropdownBehavior();
  });
});


//------------------------menu-dropdown-js-end--------------------  
$(document).ready(function () {
  $(document).on("change", 'input[name="color"]', function () {
    var selectedColor = $(this).val().trim();
    $('#selected-frame-name span').text(selectedColor);

    $('#main-gallery .single-pro-image').each(function () {
      var color_group = $(this).attr('data-color-group');
      if (color_group === selectedColor) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    if ($(window).width() <= 768) {
      var $mobileSlider = $('#gallery .single-product-slider');
      var foundIndex = -1;
      $mobileSlider.find('.owl-stage .owl-item:not(.cloned) .single-pro-image').each(function (index) {
        var color_group = $(this).attr('data-color-group');
        if (color_group === selectedColor) {
          foundIndex = index;
          return false;
        }
      });
      if (foundIndex >= 0) {
        $mobileSlider.trigger('to.owl.carousel', [foundIndex, 300]);
      }
    }

    var variantId = window.colorVariantMap[selectedColor];
    if (variantId) {
      var $form = $('.product-form form');
      $form.find('input[name="id"]').val(variantId);
      $form.trigger('change');
    }
  });
});

function checkradio(productmainid){
console.log(productmainid);


 }
$('.variantcollswatch').on('click', function () {
  var ddinvt = $(this).attr('data-inventory');
  var productId = $(this).data('productmainid'); // get related product ID
  var $button = $('#ProductSubmitButton-' + productId); // target the correct button
  var $buttonText = $button.find('span');

  if (parseInt(ddinvt) === 0) {
    $button.prop('disabled', true); // disable the button
    $buttonText.text('Sold Out');   // change text
  } else {
    $button.prop('disabled', false);
    $buttonText.text('Add to Cart');
  }
});

 //------------------------new variant collection image change -------------------- 
// $(document).ready(function () {
//   let swatchClicked = false; 

//   $('.variantcollswatch').on('click', function () {
    
//       const $swatchList = $(this).closest('.swatch-list'); 
//   const $grid = $swatchList.closest('grid-color-swatches');
//   $grid.find('.swatch-list').removeClass('activeclas');
//     swatchClicked = true;

//     var swatchVarId = $(this).data('productmainid');
//     var swatchValue = $(this).attr('data-value');
//     var productHandle = $(this).data('product-handle');
//     var image = $('.customcarimg-' + swatchVarId + ' img');
//     var imageUrl = $(this).attr('data-variant-image');

//     if (!imageUrl || !swatchVarId) return;

//     // Update image sources
//     image.attr('src', imageUrl);
//     image.attr('srcset', `
//       ${imageUrl}&width=165 165w,
//       ${imageUrl}&width=360 360w,
//       ${imageUrl}&width=533 533w,
//       ${imageUrl}&width=720 720w,
//       ${imageUrl}&width=940 940w,
//       ${imageUrl}&width=1066 1066w,
//       ${imageUrl} 2048w
//     `);
//     image.attr('sizes', '(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)');

//     // Store selected swatch for use on product page
//     localStorage.setItem('selectedSwatch', JSON.stringify({
//       color: swatchValue,
//       handle: productHandle
//     }));

//     //console.log('Swatch clicked:', swatchValue, 'for product:', productHandle);
//   });

//   // When image (.pwsinner_cart) is clicked
//   $('.pwsinner_cart img').on('click', function () {
//     if (swatchClicked) {
     
//       swatchClicked = false;

//       //console.log('Image clicked after swatch — swatch logic applied.');

//     } else {
//       // Swatch NOT clicked before image — run image click logic

//       const variname = $(this).attr('variname');
//       const productLink = $(this).closest('a').attr('href') || '';
//       let productHandle = null;

//       if (productLink.includes('/products/')) {
//         productHandle = productLink.split('/products/')[1];
//       }

//       if (variname) {
//         localStorage.setItem('selectedSwatch', JSON.stringify({
//           color: variname,
//           handle: productHandle
//         }));

//         //console.log('Image clicked directly — stored variname:', variname);
//       }
//     }
//   });

//   // On product page load — auto select stored swatch
//   const swatchData = JSON.parse(localStorage.getItem('selectedSwatch'));
//   if (swatchData) {
//     const currentHandle = window.location.pathname.split('/products/')[1];

//     if (currentHandle && currentHandle.includes(swatchData.handle)) {
//       const swatchInput = $(`input[name="color"][value="${swatchData.color}"]`);
//       if (swatchInput.length) {
//         swatchInput.prop('checked', true).trigger('change');
//         console.log(`Auto-selected swatch: ${swatchData.color}`);
//       } else {
//         console.warn(`Swatch input for "${swatchData.color}" not found.`);
//       }
//     }
//     localStorage.removeItem('selectedSwatch');
//   }

// $('.pwsinner_cart').each(function () {
//   const variname = $(this).attr('imgvarid'); 

//   const gridSwatch = $(`grid-color-swatches[data-divvari="${variname}"]`);

//   if (gridSwatch.length) {
//     gridSwatch.find('input[data-variant-id]').each(function () {
//       const inputVariantId = $(this).attr('data-variant-id');

//       if (inputVariantId === variname) {
//      $(this).closest('.swatch-list').addClass('activeclas');
//         console.log('Activated swatch for variant:', variname);
//       }
//     });
//   }
// });





// });

$(document).ready(function () {
  let swatchClicked = false; 

  // Handle variant swatch click
  $('.variantcollswatch').on('click', function () {
    const $swatchList = $(this).closest('.swatch-list'); 
    const $grid = $swatchList.closest('grid-color-swatches');
    $grid.find('.swatch-list').removeClass('activeclas');
    swatchClicked = true;

    const swatchVarId = $(this).data('productmainid');
    const swatchValue = $(this).attr('data-value');
    const productHandle = $(this).data('product-handle');
    const image = $('.customcarimg-' + swatchVarId + ' img');
    const imageUrl = $(this).attr('data-variant-image');

    if (!imageUrl || !swatchVarId) return;

    // Update image sources
    image.attr('src', imageUrl);
    image.attr('srcset', `
      ${imageUrl}&width=165 165w,
      ${imageUrl}&width=360 360w,
      ${imageUrl}&width=533 533w,
      ${imageUrl}&width=720 720w,
      ${imageUrl}&width=940 940w,
      ${imageUrl}&width=1066 1066w,
      ${imageUrl} 2048w
    `);
    image.attr('sizes', '(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)');

    // Store selected swatch for use on product page
    localStorage.setItem('selectedSwatch', JSON.stringify({
      color: swatchValue,
      handle: productHandle
    }));

    // Inventory check and display
    var inventory = $(this).data('inventory');
    $('.inventory-info').remove(); // Remove any previous inventory info

    if (parseInt(inventory) === 0) {
      var message = `Sold Out`;

      $(this).closest('.varproductcolor').before(
        `<span class="inventory-info" style="display:block; margin-top: 8px; font-weight: bold; color: red;">${message}</span>`
      );
    }
  });

  // When image (.pwsinner_cart) is clicked
  $('.pwsinner_cart img').on('click', function () {
    if (swatchClicked) {
      swatchClicked = false;
    } else {
      // Image clicked before swatch — run image click logic
      const variname = $(this).attr('variname');
      const productLink = $(this).closest('a').attr('href') || '';
      let productHandle = null;

      if (productLink.includes('/products/')) {
        productHandle = productLink.split('/products/')[1];
      }

      if (variname) {
        localStorage.setItem('selectedSwatch', JSON.stringify({
          color: variname,
          handle: productHandle
        }));
      }
    }
  });

  // On product page load — auto select stored swatch
const swatchData = JSON.parse(localStorage.getItem('selectedSwatch'));
if (swatchData) {
  const currentHandle = window.location.pathname.split('/products/')[1];

  if (currentHandle && currentHandle.includes(swatchData.handle)) {
    const swatchInput = $(`input[name="color"][value="${swatchData.color}"]`);
    if (swatchInput.length) {
      swatchInput.prop('checked', true).trigger('change').trigger('click'); // ✅ Ensure full variant selection

      // Optional: Also select dropdown variant if available
      const variantId = swatchInput.data('variant-id');
      if (variantId) {
        const variantSelect = $('form[action*="/cart/add"] select[name="id"]');
        if (variantSelect.length) {
          variantSelect.val(variantId).trigger('change');
        }
      }

      console.log(`Auto-selected swatch: ${swatchData.color}`);
    } else {
      console.warn(`Swatch input for "${swatchData.color}" not found.`);
    }
  }

  localStorage.removeItem('selectedSwatch');
}

  // Handle image variant match
  $('.pwsinner_cart').each(function () {
    const variname = $(this).attr('imgvarid');
    const gridSwatch = $(`grid-color-swatches[data-divvari="${variname}"]`);

    if (gridSwatch.length) {
      gridSwatch.find('input[data-variant-id]').each(function () {
        const inputVariantId = $(this).attr('data-variant-id');

        if (inputVariantId === variname) {
          $(this).closest('.swatch-list').addClass('activeclas');
        }
      });
    }
  });
});





